import React from 'react';
import PropTypes from 'prop-types';

import TimeSavedBlock from 'login/components/Transaction/TimeSavedBlock/TimeSavedBlock.jsx';

import 'login/components/Transaction/TransactionActionDetails/TransactionActionDetails.scss';

const TransactionActionDetails = ({ timeSaved, children }) => {
    return (
        <div className="TransactionActionDetails--wrapper">
            {children}
            {timeSaved > 0 && <TimeSavedBlock timeSaved={timeSaved} />}
        </div>
    );
};

TransactionActionDetails.propTypes = {
    children: PropTypes.element.isRequired,
    timeSaved: PropTypes.number,
};

TransactionActionDetails.defaultProps = {
    timeSaved: 0,
};

TransactionActionDetails.displayName = 'TransactionActionDetails';

export default TransactionActionDetails;



// WEBPACK FOOTER //
// ./src/components/Transaction/TransactionActionDetails/TransactionActionDetails.jsx